import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'objNgFor',
    pure:false
})
export class ObjNgForPipe implements PipeTransform {

  transform(value: any, args?: any): any {
      return Object.keys(value);
  }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/shared/pipes/obj-ng-for.pipe.ts